import React, { ReactElement, ReactNode } from "react";
import styled from "styled-components/macro";
import { Radio } from ".";

const StyledRoot = styled.div<{
  layout?: "horizontal" | "vertical";
  error?: string;
}>`
  display: ${(props) => (props.layout === "horizontal" ? "flex" : "block")};
  align-items: center;

  .radiogroup-title {
    margin-bottom: ${(props) =>
      props.layout === "horizontal" ? "0" : "0.25rem"};
    padding-right: ${(props) => (props.layout === "horizontal" ? "1rem" : "0")};
  }

  .radios {
    ${(props) => (props.error ? "border: 1px solid red;" : "")}
    border-radius: var(--rounded-corner);
    display: ${(props) => (props.layout === "horizontal" ? "flex" : "block")};
  }

  .radio-item {
    padding: 0.375rem 0.5rem;
    cursor: pointer;
    border-radius: var(--rounded-corner);
    label {
      cursor: pointer;
      line-height: 1.2;
    }
    &:hover {
      background: var(--background-green);
    }
  }

  .error {
    color: var(--error-color);
  }
`;

export type RadioOption = {
  label: string | ReactNode;
  value: string;
  subComponent?: ReactElement;
};

export interface RadioProps {
  label: string;
  options: RadioOption[];
  onChange: (v: string) => void;
  className?: string;
  isRequired?: boolean;
  selectedItem?: string;
  layout?: "horizontal" | "vertical";
  disabled?: boolean;
  error?: string;
}

export const RadioGroup = ({
  label,
  options,
  onChange,
  className,
  isRequired,
  selectedItem,
  disabled,
  error,
  layout = "vertical",
}: RadioProps): ReactElement => {
  return (
    <StyledRoot
      className={`label font-small ${error ? "field-error" : ""} ${
        className ?? ""
      }`}
      layout={layout}
      error={error}
    >
      {label.length ? (
        <div className="radiogroup-title">
          {label}
          {isRequired && <span className="error">*</span>}
        </div>
      ) : null}

      <div className="radios">
        {options.map((option, index) => {
          const selected = selectedItem === option.value;
          return (
            <React.Fragment key={option.value}>
              <Radio
                disabled={disabled}
                className="radio-item"
                key={`${option.value}-${index}`}
                onChange={() => {
                  onChange(option.value);
                }}
                label={option.label}
                value={option.value}
                name={label}
                checked={selected}
              />
              {selected ? option.subComponent : undefined}
            </React.Fragment>
          );
        })}
      </div>
      <div className="error">{error ?? " "}</div>
    </StyledRoot>
  );
};
